import React from "react";
import DataTable from "react-data-table-component";
import moment from "moment";
import CurrencyInput from "react-currency-input-field";
import Moment from "moment";
import Select from "react-select";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  TabContent,
  TabPane,
  Container,
  Collapse,
  Row,
  Col,
  Tab,
  Modal,
  ModalBody,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { number } from "prop-types";
import { InfinitySpin, Oval, Hourglass } from "react-loader-spinner";
import ReactPaginate from "react-paginate";
import { getGroupFormPenilaian } from "stores";
import { updateStatusFormGroup } from "stores";
import Swal from "sweetalert2";
import { addGroupFormPenilaian } from "stores";
import JenisPenilaian from "./JenisPenilaian";
import { detailGrupPenilaian } from "stores";

function Scoring() {
  const auth = useSelector((state) => state.authReducer);
  const listScoring = useSelector((state) => state.scoringReducer);
  const [modal, setModal] = React.useState(false);
  const dispatch = useDispatch();
  const [listGroup, setListGroup] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [pending, setPending] = React.useState(false);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [namaGroup, setNamaGroup] = React.useState("");
  const [idGroupPenilaian, setIdGroupPenilaian] = React.useState("");
  const [modalDetail, setModalDetail] = React.useState(false);
  const [dataDetail, setDataDetail] = React.useState("");
  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleFilterChange = () => {
    setPending(true);
    getGroupFormPenilaian(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      cari: searchText,
    })
      .then((response) => {
        setPending(false);
      })
      .catch((error) => {
        setPending(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleDetailsClick = (val) => {
    setModalDetail(true);
    detailGrupPenilaian(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      cari: searchText,
      idGroupFormPenilaian: val.idGroupFormPenilaian,
    })
      .then((response) => {
        setDataDetail(response.data[0]);
        setPending(false);
      })
      .catch((error) => {
        setPending(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
    // dispatch({ type: "SET_KIRIM_DETAIL_NASABAH", data: val });
  };

  const tampilJenisPenilaian = (val) => {
    dispatch({ type: "SET_SHOW_JENIS_PENILAIAN", data: false });
    dispatch({ type: "SET_SHOW_KRITERIA_PENILAIAN", data: true });
    dispatch({ type: "SET_SHOW_PARAMETER_PENILAIAN", data: true });

    setIdGroupPenilaian(val);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const tambahFormGroup = () => {
    if (!namaGroup) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Silahkan isi nama grup!",
      });
    } else {
      addGroupFormPenilaian({
        namaGroup: namaGroup,
      })
        .then((response) => {
          if (response.status === 200) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: response.message,
              showConfirmButton: false,
              timer: 1500,
            });
            setModal(false);
            getGroupFormPenilaian(dispatch, {
              page: page + 1,
              limit: totalPerHalaman,
              cari: searchText,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.message,
            });
          }
        })
        .catch((err) => {
          console.log("ERROR :", err);
        });
    }
  };

  const updateStatusGroup = (idFormGroup) => {
    Swal.fire({
      position: "center",
      icon: "question",
      title: "Yakin ingin mengaktifkan grup ini?",
      showDenyButton: true,
      cancelButtonColor: "#E22016",
      confirmButtonText: "Ya",
      denyButtonText: `Tidak`,
      allowOutsideClick: false,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        updateStatusFormGroup({
          idGroupFormPenilaian: idFormGroup,
          status: true,
        })
          .then((response) => {
            if (response.status === 200) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: response.message,
                showConfirmButton: false,
                timer: 1500,
              });
              getGroupFormPenilaian(dispatch, {
                page: page + 1,
                limit: totalPerHalaman,
                cari: searchText,
              });
            } else if (response.status === 400) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response.message,
              });
            }
          })
          .catch((err) => {
            console.log("ERROR :", err);
          });
      }
    });
  };
  const getStatusFormPenilaian = (status) => {
    switch (status) {
      case true:
        return {
          fontWeight: "bold",
          backgroundColor: "#D4FFC6",
          textColor: "#2AAA00",
        };
      case false:
        return {
          fontWeight: "bold",
          backgroundColor: "#FBECEC",
          textColor: "#DB5856",
        };

      default:
        return {};
    }
  };

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const customStyles = {
    rows: {
      style: {
        height: 50, // override the row height
      },
    },
    headRow: {
      style: {
        minHeight: 35,
        backgroundColor: "#F8F8F8",
        // fontFamily: "Poppins",
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        minHeight: 50,
        fontWeight: "bold",
        fontSize: 14,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
    cells: {
      style: {
        minHeight: 50,
        "&:first-child": {
          borderRight: "1px solid #ccc", // Menambahkan garis pembatas di sebelah kanan sel pertama
        },
      },
    },
  };

  React.useEffect(() => {
    dispatch({ type: "SET_SHOW_JENIS_PENILAIAN", data: true });
    dispatch({ type: "SET_SHOW_KRITERIA_PENILAIAN", data: true });
    dispatch({ type: "SET_SHOW_PARAMETER_PENILAIAN", data: true });
  }, []);

  React.useEffect(() => {
    if (listScoring.getListGroupPenilaian.data) {
      let tmp = listScoring.getListGroupPenilaian.data.map((val) => {
        return {
          ...val,
          action: (
            <>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Ubah Status</Tooltip>}
              >
                <Button
                  className="mr-0"
                  // variant="info"
                  style={{
                    marginTop: 5,
                    backgroundColor: val.statusAktif ? "#157DEC" : "#E22016",
                    border: 0,
                    cursor: val.statusAktif ? "not-allowed" : "pointer",
                  }}
                  disabled={val.statusAktif ? true : false}
                  onClick={() => {
                    updateStatusGroup(val.idGroupFormPenilaian);
                  }}
                >
                  <i class="fas fa-sync"></i>
                </Button>
              </OverlayTrigger>{" "}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Tambah Jenis Penilaian</Tooltip>}
              >
                <Button
                  className="mr-0"
                  // variant="info"
                  style={{
                    marginTop: 5,
                    backgroundColor: "#00555A",
                    border: 0,
                  }}
                  onClick={() => {
                    tampilJenisPenilaian(val.idGroupFormPenilaian);
                  }}
                >
                  <i class="fas fa-layer-group"></i>
                </Button>
              </OverlayTrigger>{" "}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Details Scoring</Tooltip>}
              >
                <Button
                  className="mr-0"
                  // variant="info"
                  style={{
                    marginTop: 5,
                    backgroundColor: "#65869F",
                    border: 0,
                  }}
                  onClick={() => handleDetailsClick(val)}
                >
                  <i class="fas fa-info"></i>
                </Button>
              </OverlayTrigger>
            </>
          ),
        };
      });
      setListGroup(tmp);
    }
  }, [listScoring.getListGroupPenilaian]);

  React.useEffect(() => {
    setPending(true);
    getGroupFormPenilaian(dispatch, {
      cari: searchText,
      page: page + 1,
      limit: totalPerHalaman,
    })
      .then(() => {
        setPending(false);
      })
      .catch((error) => {
        setPending(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [page, totalPerHalaman]);

  const colListGroupPenilaian = [
    {
      name: "No",
      width: "100px",
      center: true,
      selector: (row, index) =>
        index + listScoring.getListGroupPenilaian.pagingCounter,
    },
    {
      name: "ID Grup",
      minWidth: "200px",
      center: true,
      selector: (row) => row.idGroupFormPenilaian,
    },
    {
      name: "Nama Grup",
      minWidth: "200px",
      center: true,
      selector: (row) => row.namaGroup,
    },
    {
      name: "Status",
      minWidth: "200px",
      center: true,
      selector: (row) => {
        const statusStyle = getStatusFormPenilaian(row.statusAktif);
        return (
          <div
            style={{
              fontWeight: statusStyle.fontWeight,
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {row.statusAktif ? "Aktif" : "Tidak Aktif"}
          </div>
        );
      },
    },

    {
      name: "Detail",
      minWidth: "200px",
      center: true,
      selector: (row) => row.action,
    },
  ];

  return (
    <>
      <Modal
        size="lg"
        show={modal}
        onHide={() => {
          // handleModalClose();
          setModal(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form">
            <Card.Header>
              <Card.Title
                as="h5"
                style={{ fontWeight: "bold", textTransform: "uppercase" }}
              >
                Form Tambah Grup
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Form action="#" method="#">
                <Row>
                  <Col md="12">
                    <Form.Group>
                      <label style={{ color: "black", fontWeight: "bold" }}>
                        Nama Grup
                      </label>
                      <Form.Control
                        onChange={(e) => {
                          setNamaGroup(e.target.value);
                        }}
                        placeholder="Nama Grup"
                        type="text"
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
            <Card.Footer>
              <Button
                className="btn-wd mr-0"
                variant="primary"
                onClick={tambahFormGroup}
              >
                Submit
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Modal>

      {/* MODAL DETAIL */}
      <Modal
        size="lg"
        show={modalDetail}
        onHide={() => {
          // handleModalClose();
          setModalDetail(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form" style={{ border: 0 }}>
            <Card.Header>
              <Card.Title
                as="h5"
                style={{
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  borderBottom: "2px solid #000",
                  paddingBottom: "4px", // jarak antara teks & garis
                  marginBottom: "8px",
                }}
              >
                Detail Grup {dataDetail.namaGroup}
              </Card.Title>
            </Card.Header>
            <Card.Body
              style={{
                maxHeight: "800px",
                maxWidth: "1000px",
                overflow: "auto",
              }}
            >
              <div style={{ width: "1000px", height: "auto" }}>
                <table
                  border="1"
                  cellPadding="8"
                  style={{ borderCollapse: "collapse", width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Penilaian</th>
                      <th>Bobot (%)</th>
                      <th>Kriteria</th>
                      <th>Parameter Penilaian</th>
                      <th>Score (Poin)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!dataDetail ? (
                      <tr>
                        <td colSpan={6} style={{ textAlign: "center" }}>
                          Loading...!
                        </td>
                      </tr>
                    ) : (
                      <>
                        {(() => {
                          if (dataDetail.jenisPenilaian.length === 0) {
                            return (
                              <tr>
                                <td colSpan={6} style={{ textAlign: "center" }}>
                                  Tidak ada data yang ditampilkan!
                                </td>
                              </tr>
                            );
                          } else {
                            let no = 1;
                            return dataDetail.jenisPenilaian.map(
                              (penilaian, indexPenilaian) => {
                                const totalRow = penilaian.kriteria.reduce(
                                  (sum, k) =>
                                    sum + (k.parameterPenilaian?.length || 0),
                                  0
                                );

                                return penilaian.kriteria.map(
                                  (kriteria, indexKriteria) =>
                                    kriteria.parameterPenilaian.map(
                                      (param, indexParam) => (
                                        <tr
                                          key={`${indexPenilaian}-${indexKriteria}-${indexParam}`}
                                        >
                                          {indexKriteria === 0 &&
                                            indexParam === 0 && (
                                              <>
                                                <td rowSpan={totalRow}>
                                                  {no++}
                                                </td>
                                                <td rowSpan={totalRow}>
                                                  {penilaian.jenisPenilaian}
                                                </td>
                                                <td rowSpan={totalRow}>
                                                  {penilaian.bobot}
                                                </td>
                                              </>
                                            )}

                                          {indexParam === 0 && (
                                            <td
                                              rowSpan={
                                                kriteria.parameterPenilaian
                                                  .length
                                              }
                                            >
                                              {kriteria.jenisKriteria}
                                            </td>
                                          )}

                                          <td>{param.namaParameter}</td>
                                          <td>{param.bobot}</td>
                                        </tr>
                                      )
                                    )
                                );
                              }
                            );
                          }
                        })()}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </Card.Body>
            <Card.Footer></Card.Footer>
          </Card>
        </Col>
      </Modal>
      {!auth.role ? (
        <Container
          fluid
          className=" d-flex justify-content-center align-items-center"
        >
          <Row>
            <Col className="text-center">
              <span
                style={{
                  fontWeight: "bold",
                  color: "blue",
                  fontSize: 20,
                }}
              >
                {/* Loading... */}
              </span>
            </Col>
          </Row>
        </Container>
      ) : auth.role !== "super admin" ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
            flexDirection: "column",
            // backgroundColor: "red",
          }}
        >
          <p
            style={{
              fontWeight: "bold",
              marginBottom: "1rem",
              fontSize: 30,
              color: "red",
            }}
          >
            Maaf, Anda tidak memiliki akses ke fitur ini!
          </p>
          <img
            src={require("assets/img/sorry.png").default}
            alt="Sorry"
            style={{
              maxWidth: "25%",
              display: "block",
              margin: "0 auto",
            }}
          />
        </div>
      ) : (
        <Container fluid>
          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Card.Title
                    as="h3"
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                    }}
                  >
                    grup scoring
                  </Card.Title>
                  {/* <p className="card-category">Plain text tabs</p> */}
                  <Tab.Content>
                    <Card style={{ marginTop: 20, border: 0 }}>
                      <Row
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Col md={"4"}>
                          <InputGroup>
                            <Form.Control
                              style={{
                                paddingLeft: "10px",
                              }}
                              type="text"
                              value={searchText}
                              onChange={handleSearch}
                              onKeyDown={handleKeyDown}
                              placeholder="Nama Grup"
                            />
                            <InputGroup.Append>
                              <InputGroup.Text
                                style={{ cursor: "pointer" }}
                                onClick={handleClearSearch}
                              >
                                <i class="fas fa-times"></i>
                              </InputGroup.Text>
                            </InputGroup.Append>
                          </InputGroup>
                        </Col>
                        <Col md={"8"}>
                          <Button
                            // variant="info"
                            style={{
                              fontSize: 16,
                              backgroundColor: "#00BFFF",
                              border: 0,
                              paddingTop: 10,
                              paddingBottom: 8,
                            }}
                            onClick={handleFilterChange}
                          >
                            <i class="fas fa-search"></i>
                          </Button>
                        </Col>
                      </Row>
                    </Card>
                  </Tab.Content>
                </Card.Header>
                <Card.Body>
                  <Button
                    className="btn-wd"
                    variant="primary"
                    style={{
                      // marginLeft: 0,
                      // marginTop: 10,
                      backgroundColor: "#425A6B",
                      border: 0,
                      marginBottom: 15,
                    }}
                    onClick={() => {
                      setModal(true);
                    }}
                  >
                    Tambah Grup
                  </Button>
                  {pending ? (
                    <div
                      className="loader-container"
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <div style={{ marginBottom: 20 }}>
                        <Hourglass
                          visible={true}
                          height="50"
                          width="50"
                          ariaLabel="hourglass-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                          colors={["#306cce", "#72a1ed"]}
                        />
                        {/* <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: 19,
                      }}
                    >
                      Loading ....
                    </p> */}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <DataTable
                        columns={colListGroupPenilaian}
                        data={listGroup}
                        customStyles={customStyles}
                        paginationPerPage={totalPerHalaman}
                        progressPending={pending}
                      />
                      <div style={{ marginTop: 35 }}>
                        <Row
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Col>
                            <Row style={{ alignItems: "center" }}>
                              <div
                                style={{
                                  paddingRight: 0,
                                  marginLeft: 20,
                                  marginRight: 10,
                                }}
                              >
                                <label style={{ fontWeight: "bold" }}>
                                  Rows per page
                                </label>
                              </div>
                              <Col sm="3" style={{ paddingLeft: 0 }}>
                                <Select
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  name="Pilih Client"
                                  value={options.find(
                                    (option) => option.value === totalPerHalaman
                                  )}
                                  onChange={handlePageSizeChange}
                                  options={options}
                                  placeholder="Rows per page"
                                />
                              </Col>
                            </Row>
                          </Col>

                          <Col>
                            <ReactPaginate
                              forcePage={page}
                              containerClassName="paginations justify-content-end"
                              previousClassName="pages-items-containers"
                              previousLinkClassName="pages-links-labels"
                              nextClassName="pages-items-containers"
                              nextLinkClassName="pages-links-labels"
                              breakClassName="pages-items-containers"
                              pageCount={
                                listScoring.getListGroupPenilaian.totalPages
                              }
                              pageRangeDisplayed={3}
                              marginPagesDisplayed={1}
                              pageLinkClassName="pages-links-labels"
                              pageClassName="pages-items-containers"
                              activeClassName="activees"
                              activeLinkClassName="activess"
                              nextLabel=" > "
                              previousLabel=" < "
                              initialPage={page}
                              disableInitialCallback={true}
                              onPageChange={(val) => {
                                setPage(val.selected);
                              }}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
      {listScoring.showTabelJenisPenilaian ? null : (
        <JenisPenilaian data={idGroupPenilaian} />
      )}
    </>
  );
}

export default Scoring;
